import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { RunnerId } from '@swf/generated/types/api/sports';
import useBetSlip from '@swf/sports/hooks/useBetSlip';

import {
  TXTWCL_Remove_Bet,
  TXTWCL_Selection_no_longer_available
} from './UnavailableBanner.messages.json';
import styles from './UnavailableBanner.scss';

interface Props {
  runnerId: RunnerId;
}

const UnavailableBanner: React.FC<Props> = ({ runnerId }) => {
  const { removeSelectionFromBetSlip } = useBetSlip();

  return (
    <div className={styles.unavailable}>
      <span>
        <Translation {...TXTWCL_Selection_no_longer_available} />
      </span>
      <button type="button" onClick={() => removeSelectionFromBetSlip(runnerId)}>
        <Translation {...TXTWCL_Remove_Bet} />
      </button>
    </div>
  );
};

export default UnavailableBanner;
